import {
  panel,
  refinementList,
  rangeSlider,
  // hierarchicalMenu,
} from 'instantsearch.js/es/widgets';

import { formatPrice } from '../../../../../app/Libraries/Utils';

import Filter from '../../../../../app/Models/MillbankAPI/Filter';

import { FILTERS_INITIAL_LIMIT, FILTERS_MAX_LIMIT } from '../../../../../app/Libraries/Algolia/constants';

/**
 * Wrap an algolia widget with a panel widget
 * @param filter The filter data
 * @param widget The widget to wrap with a panel
 * @param widgetOptions The options to pass to the widget
 */
const wrapWithPanel = (filter: Filter, widget, widgetOptions) => {
  const p = panel({
    hidden(options) {
      // debugger;
      const { items } = options;
      // Range slider doesn't have `options`, so always show it
      const hasItems = items && Array.isArray(items);
      if (!hasItems) {
        return false;
      }
      // Hide if only single option (or none)
      return items.length <= 1;
    },
    templates: {
      header: filter.name,
    },
    collapsed: () => false,
  })(widget);

  return p(widgetOptions);
};

export const getWidgetForFilter = (filter: Filter) => {
  switch (filter.widgetType) {
    case 'rangeSlider':
      return () => wrapWithPanel(filter, rangeSlider, {
        container: `#specifications-${filter.slug}`,
        // TODO: Are these always going to be specs? Or do we need to add "specs" to the attribute name elsewhere?
        attribute: `specifications.${filter.slug}`,
        pips: false,
      });
    case 'priceRangeSlider':
      return () => wrapWithPanel(filter, rangeSlider, {
        container: `#specifications-${filter.slug}`,
        attribute: `specifications.${filter.slug}`,
        pips: false,
        tooltips: {
          format(rawValue: number) {
            return formatPrice(rawValue, 'usd', false);
          },
        },
      });

      // TODO: Not sure how best to do hierarchal menu or if we need to...
      // case 'hierarchicalMenu':
      //   return (container) =>
      //     panel({ templates: { header: filter.name }, collapsed: () => false })
      //     (hierarchicalMenu)({ container, attributes: [
      //       'productGroup.menu.lvl0',
      //       'productGroup.menu.lvl1',
      //       'productGroup.menu.lvl2',
      //     ], showMore: true });

    // Refinement list is the default
    default:
      return () => wrapWithPanel(filter, refinementList, {
        container: `#specifications-${filter.slug}`,
        attribute: `specifications.${filter.slug}`,
        // NOTE: searching is enabled on all specs,
        // but we're hiding the search box with CSS until there are > 30 options via CSS
        searchable: true,
        limit: FILTERS_INITIAL_LIMIT,
        showMore: true,
        showMoreLimit: FILTERS_MAX_LIMIT,
      });
  }
};
